
import StringifiedParameterFormatter from '../formatters/StringifiedParameterFormatter.js';
import { HitData, PitchData, ResultData, ScoringData, PitchResultCombined } from '../enums/index.js';
import { ChartSeries, Series, BaseballResultsProcessor } from '../entities/index.js';
import { ResultPair } from '../valueObjects/index.js';
import { buildFiltersArray } from './SprayChartSeriesProvider.js';

const getSeriesForSprayChart = function(
    results, customResultsProcessor,
    {
        // tagging context
        batterIds, pitchResults, pitchTypes, pitcherIds, zones, pitcherHandedness,
        // scoring context
        outs, balls, strikes, runnersOn,
    } = {}
) {
    let chartSeries = [];
    let resultsProcessor = customResultsProcessor || new BaseballResultsProcessor();
    let chartFilters = buildFiltersArray({
        batterIds, pitchResults, pitchTypes, pitcherIds, zones, pitcherHandedness,
        outs, balls, strikes, runnersOn
    });

    // match pitch and hit...
    let matchedResults = BaseballResultsProcessor.matchPitchesAndHits(results);
    let pairsWithLocation = resultsProcessor.filterData(matchedResults, chartFilters);
    // this is rare case but possible, so there was hit without pitch matched to it
    //mergeHitsWithoutPitchResult(pairsPerPitchResult);

    // in order to keep it compatible with old scoring structure and extended tagging, we will need to group it by combined pitch result...
    const combinedPitchResults = [];
    const resultPath = [ResultPair.getPitchProperty()].concat(ResultData.getDataPath(PitchData.Result.key));
    const paResultPath = [ResultPair.getPitchProperty()].concat(ResultData.getDataPath(ScoringData.PlateAppearanceResult.key));
    const pitchCallPath = [ResultPair.getPitchProperty()].concat(ResultData.getDataPath(ScoringData.PitchCall.key));

    for (let i = 0; i < pairsWithLocation.length; i++) {
        const result = pairsWithLocation[i];
        const paResult = resultsProcessor.getObjectContent(result, paResultPath);
        let combinedPitchResult = null;
        if (paResult) {
            const pitchCall = resultsProcessor.getObjectContent(result, pitchCallPath);
            // set unidentified as a fallback
            combinedPitchResult = PitchResultCombined.matchToNewScoring(paResult, pitchCall) || PitchResultCombined.Unidentified;
        }
        else {
            const pitchResult = resultsProcessor.getObjectContent(result, resultPath);
            // set unidentified as a fallback
            combinedPitchResult = PitchResultCombined.matchToOldScoring(pitchResult) || PitchResultCombined.Unidentified;
        }

        if (!combinedPitchResults.hasOwnProperty(combinedPitchResult.key)) {
            combinedPitchResults[combinedPitchResult.key] = [];
        }

        combinedPitchResults[combinedPitchResult.key].push(result);
    }

    for (const combinedPitchResultKey in combinedPitchResults) {
        const resultsPerCategory = combinedPitchResults[combinedPitchResultKey];
        const currentCategory = new Series(combinedPitchResultKey, 2);
    
        let resultsMapped = resultsProcessor.mapCollectionProperties(resultsPerCategory, [
            [ResultPair.getHitProperty(), ResultData.Id.key],
            [ResultPair.getHitProperty(), ResultData.PitchId.key],
            [ResultPair.getHitProperty()].concat(ResultData.getDataPath(HitData.LandingPoint.key))
        ]);

        for (let i = 0; i < resultsMapped.length; i++) {
            let formatted = StringifiedParameterFormatter(
                resultsMapped[i][HitData.LandingPoint.key], ';', HitData.LandingPoint.stringifiedAs, parseFloat
            );

            currentCategory.add(resultsMapped[i][ResultData.Id.key], formatted.X, formatted.Y);
        }

        chartSeries.push(currentCategory);
    }

    return new ChartSeries(chartSeries, Object.keys(combinedPitchResults));
};

export default getSeriesForSprayChart;